export default "__VITE_ASSET__Cj$Rq87c__"